export type StandbyWaitlistLeaveSession = {
  leaveToken?: string;
  leaveTokenExpiresAt?: string;
  shopRoute: string;
  barberId: string;
  cartId?: string;
};

const sessions = new Map<string, StandbyWaitlistLeaveSession>();

export const setStandbyWaitlistLeaveSession = (
  entryId: string,
  session: StandbyWaitlistLeaveSession,
): void => {
  sessions.set(entryId, session);
};

export const dropStandbyWaitlistLeaveSession = (entryId: string): void => {
  sessions.delete(entryId);
};

export const getStandbyWaitlistLeaveSession = (
  entryId: string,
  now: number = Date.now(),
): StandbyWaitlistLeaveSession | undefined => {
  const session = sessions.get(entryId);
  // A join can succeed without a leave token; that session only carries the
  // visit, so it has nothing to expire.
  if (!session?.leaveToken) return session;

  const expiresAt = Date.parse(session.leaveTokenExpiresAt ?? '');
  if (Number.isNaN(expiresAt) || now >= expiresAt) {
    sessions.delete(entryId);
    return undefined;
  }
  return session;
};
